import { Cadastre as ApiCadastre } from '../realty/model/Cadastre';
import { defined, evaluate } from '../utility/Control';
import { ApiDate } from '../realty/model/ApiDate';
import { CadastreIdent } from '../realty/model/CadastreIdent';
import { Address as ApiAddress } from '../realty/model/Address';
import { Address } from './Address';
import { SoilContamination } from '../realty/model/SoilContamination';
import { SingleHeritage } from '../realty/model/SingleHeritage';

export class Cadastre {
  public key: string;
  public ident: CadastreIdent;
  public municipalityName: string;
  public establishedDate: ApiDate;
  public leasehold: boolean;
  public agriculturalCadastre: boolean;
  public zeroConcession: boolean;
  public specifiedArea: number;
  public address: Address;
  public soilContaminations: SoilContamination[] = [];
  public singleHeritages: SingleHeritage[] = [];

  public constructor(apiCadastre: ApiCadastre) {
    this.key = apiCadastre.key;
    this.ident = apiCadastre.ident;
    this.municipalityName = evaluate(apiCadastre, 'municipality.municipalityName');
    this.establishedDate = apiCadastre.establishedDate;
    const code = evaluate(apiCadastre, 'maxCadastreLevel.code');
    if (defined(code)) {
      const min = 2;
      this.leasehold = parseInt(code, 10) > min; // TODO: Ask Terje if this is correct
    }
    this.agriculturalCadastre = apiCadastre.agriculturalCadastre;
    this.zeroConcession = apiCadastre.zeroConcession;
    this.specifiedArea = apiCadastre.specifiedArea;
    const apiAddress: ApiAddress = evaluate(apiCadastre, 'inclusions.presentationAddress.item');
    if (defined(apiAddress)) {
      this.address = new Address(apiAddress);
    }
    this.soilContaminations = evaluate(apiCadastre, 'inclusions.soilContaminations.items');
    this.singleHeritages = evaluate(apiCadastre, 'inclusions.singleHeritages.items');
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Cadastre.ts
 **/